// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.parameter_source_type_enum */
var ParameterSourceTypeEnum;
(function (ParameterSourceTypeEnum) {
    ParameterSourceTypeEnum["PROTOCOL"] = "PROTOCOL";
    ParameterSourceTypeEnum["OPERATOR"] = "OPERATOR";
    ParameterSourceTypeEnum["BREWCONTROL"] = "BREWCONTROL";
})(ParameterSourceTypeEnum || (ParameterSourceTypeEnum = {}));
;
export default ParameterSourceTypeEnum;
/** Zod schema for parameter_source_type_enum */
export const parameterSourceTypeEnum = z.nativeEnum(ParameterSourceTypeEnum);
//# sourceMappingURL=ParameterSourceTypeEnum.js.map